import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { BasePrimaryText } from '../../common.styles';

export const AccordionRow = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  padding: '15px 0',
})``;

export const AccordionRowText = styled(BasePrimaryText)`
  flex: 1 1 auto;
`;

export const AccessPageContentRowText = styled(AccordionRowText)`
  color: ${p =>
    p.isGrayedOut ? p.theme.colors.secondaryLink : p.theme.colors.primaryText};
`;
